// extracted by mini-css-extract-plugin
module.exports = {"times":"MainTable_times__3eJ2O"};